import { useState } from "react";
import axios from "axios";
import css from "../index.module.css";
import { toast } from "sonner";
import useUserData from "@hooks/useUserData";
import usePush from "@hooks/usePush";
import Popup from "@components/popup";

export default function Settings() {
  const { userData, refreshUserData, logout } = useUserData();
  const { subscribe, isSubscribed, isApp, isLoading, error } = usePush();
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [confirmChecked, setConfirmChecked] = useState(false);

  const closeDeleteConfirm = () => {
    if (deleteLoading) return;
    setConfirmDeleteOpen(false);
    setConfirmChecked(false);
  };

  const setConfirmDeleteOpenSafe = (value: boolean) => {
    if (value) {
      setConfirmDeleteOpen(true);
      return;
    }
    closeDeleteConfirm();
  };

  const confirmDeleteAccount = async () => {
    if (!confirmChecked || deleteLoading) return;

    setDeleteLoading(true);
    try {
      await axios.delete(`${import.meta.env.VITE_API_URL}/user`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      toast.success("Аккаунт удалён");
      logout();
    } catch (err) {
      console.log(err);
      toast.error("Не удалось удалить аккаунт");
      setDeleteLoading(false);
    }
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    axios
      .post(`${import.meta.env.VITE_API_URL}/user`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((_) => {
        toast.success("Данные успешно обновлены");
        refreshUserData();
      })
      .catch((_) => {
        toast.error("Ошибка обновления данных");
      });
  };

  return (
    <div className={css.col1}>
        <div className={css.accountInfo}>
            <form className={css.form} onSubmit={handleSubmit}>
            <div className={css.flex}>
                <b className={css.headAcc}>Личные данные</b>
                <label>Имя</label>
                <input
                type="text"
                name="firstName"
                defaultValue={userData.firstName}
                placeholder="Имя"
                />
                <label>Фамилия</label>
                <input
                type="text"
                name="lastName"
                defaultValue={userData.lastName}
                placeholder="Фамилия"
                />
                <label>Имя пользователя</label>
                <input
                type="text"
                name="username"
                defaultValue={userData.username}
                placeholder="Имя пользователя"
                />
            </div>

            <button>Сохранить информацию</button>
            <a
                onClick={logout}
                style={{
                color: "#000",
                cursor: "pointer",
                background: "#fff",
                border: "1px solid #00000075",
                padding: "10px",
                borderRadius: 10,
                textAlign: "center",
                display: "block",
                marginTop: 0,
                }}
            >
                Выйти из аккаунта
            </a>

            <b className={css.headAcc} style={{ marginTop: 20}}>Уведомления</b>

            {isSubscribed &&
                <div className={css.notificationSubscribed}>
                <i className="fi fi-rr-check-circle"></i>
                <span>Уведомления подключены</span>
                </div>
            }

            {!isSubscribed && !isApp && (
                <button
                type="button"
                onClick={() => subscribe()}
                disabled={isLoading}
                >
                <i
                    className="fi fi-rr-bell"
                    style={{
                    marginRight: 10,
                    top: 2.5,
                    position: "relative",
                    }}
                />
                Включить PUSH-уведомления
                </button>
            )}
            {error && <span>{error}</span>}
            </form>

            <div className={css.deleteAccountSection}>
              <b className={css.headAcc}>Удаление аккаунта</b>
              <p className={css.deleteAccountHint}>
                Аккаунт и связанные с ним данные будут удалены безвозвратно.
                Это не деактивация — восстановить профиль будет нельзя.
              </p>
              <button
                type="button"
                className={css.deleteAccountBtn}
                onClick={() => setConfirmDeleteOpen(true)}
              >
                <i className="fi fi-rr-trash"></i> Удалить аккаунт
              </button>
            </div>
        </div>

        <Popup showPopup={confirmDeleteOpen} setShowPopup={setConfirmDeleteOpenSafe}>
          <div className={css.deleteConfirmPopup}>
            <h1>Удалить аккаунт?</h1>
            <p className={css.deleteAccountHint}>
              Будут удалены личные данные, адреса, организации, корзина
              и история заказов. Это действие нельзя отменить.
            </p>
            <label className={css.deleteConfirmCheck}>
              <input
                type="checkbox"
                checked={confirmChecked}
                onChange={(e) => setConfirmChecked(e.target.checked)}
                disabled={deleteLoading}
              />
              <span>Я понимаю, что аккаунт будет удалён безвозвратно</span>
            </label>
            <div className={css.confirmActions}>
              <button
                type="button"
                className={css.cancelBtn}
                onClick={closeDeleteConfirm}
                disabled={deleteLoading}
              >
                Отмена
              </button>
              <button
                type="button"
                className={css.dangerBtn}
                onClick={confirmDeleteAccount}
                disabled={deleteLoading || !confirmChecked}
              >
                {deleteLoading ? "Удаляем..." : "Удалить аккаунт"}
              </button>
            </div>
          </div>
        </Popup>
    </div>
  );
}
